import { productImageMap } from './productImages.generated';

const productData = [
  {
    id: 1,
    name: "100 Python Automation Scripts",
    category: "Python Development",
    price: 99,
    image: "/images/products/python/automation-scripts.webp",
    shortDescription: "Ready-to-use Python scripts for automating daily tasks and workflows",
    description: "A comprehensive collection of 100 professionally written Python scripts for automating system administration, file management, data processing, web scraping, and more. Each script is thoroughly documented and customizable.",
    features: [
      "System automation",
      "File management",
      "Data processing",
      "Web scraping",
      "Task scheduling"
    ],
    specifications: {
      "Python Version": "Python 3.8+",
      "Total Scripts": "100+",
      "Code Coverage": "95%",
      "Documentation": "Full inline documentation and README",
      "Dependencies": "Standard library + common packages",
      "OS Compatibility": "Windows, Linux, macOS",
      "Skill Level": "Beginner to Intermediate",
      "Updates": "Quarterly",
      "Support": "Email support"
    }
  },
  {
    id: 2,
    name: "700+ Python Automation Tools",
    category: "Python Development",
    price: 283,
    image: "/images/products/python/automation-tools.webp",
    shortDescription: "Complete toolkit of Python automation utilities and frameworks",
    description: "An extensive collection of 700+ Python tools covering automation frameworks, testing utilities, deployment scripts, monitoring tools, and workflow automation solutions. Perfect for developers and system administrators.",
    features: [
      "Automation frameworks",
      "Testing utilities",
      "Deployment tools",
      "Monitoring solutions",
      "Workflow automation"
    ],
    specifications: {
      "Python Version": "Python 3.7+",
      "Total Tools": "700+",
      "Code Coverage": "98%",
      "Testing Framework": "pytest, unittest",
      "CI/CD Integration": "GitHub Actions, Jenkins, GitLab CI",
      "Documentation": "Sphinx documentation + API reference",
      "Dependencies": "Requirements.txt included",
      "OS Compatibility": "Cross-platform",
      "Updates": "Monthly"
    }
  },
  {
    id: 3,
    name: "Advanced Cybersecurity SOC concepts",
    category: "Cybersecurity Training",
    price: 340,
    image: "/images/products/security/soc-concepts.webp",
    shortDescription: "In-depth guide to modern Security Operations Center practices",
    description: "Comprehensive training material covering advanced SOC concepts, including threat hunting, incident response, SIEM implementation, threat intelligence, and security automation. Includes real-world case studies and hands-on labs.",
    features: [
      "Threat hunting",
      "Incident response",
      "SIEM implementation",
      "Threat intelligence",
      "Security automation"
    ],
    specifications: {
      "Course Duration": "40+ hours",
      "Difficulty Level": "Advanced",
      "Materials": "Video lectures, PDF guides, Labs",
      "Lab Environment": "Virtual machines included",
      "Prerequisites": "Basic cybersecurity knowledge",
      "Certification": "Certificate of completion",
      "Updates": "Quarterly content updates",
      "Support": "24/7 instructor support",
      "Access Period": "Lifetime"
    }
  },
  {
    id: 4,
    name: "AI & Machine Learning Handbooks",
    category: "AI & Machine Learning",
    price: 324,
    image: "/images/products/ai/ml-handbook.webp",
    shortDescription: "Complete guides for modern AI and ML development",
    description: "Expert-curated handbooks covering machine learning algorithms, deep learning frameworks, neural networks, computer vision, natural language processing, and practical AI implementation strategies.",
    features: [
      "ML algorithms",
      "Deep learning",
      "Neural networks",
      "Computer vision",
      "NLP techniques"
    ],
    specifications: {
      "Format": "PDF + Interactive Jupyter notebooks",
      "Pages": "1000+",
      "Frameworks Covered": "TensorFlow, PyTorch, Scikit-learn",
      "Code Examples": "200+ practical examples",
      "Difficulty Level": "Intermediate to Advanced",
      "Prerequisites": "Python, Basic Statistics",
      "Updates": "Bi-annual updates",
      "Includes": "Source code, datasets, models",
      "Support": "Email support"
    }
  },
  {
    id: 5,
    name: "Analytics Dashboard Template",
    category: "Data Analytics",
    price: 227,
    image: "/images/products/analytics/dashboard.webp",
    shortDescription: "Modern analytics dashboard with advanced visualization features",
    description: "Professional dashboard template built with React and D3.js, featuring real-time data visualization, customizable charts, interactive filters, and support for multiple data sources. Includes dark/light themes and responsive design.",
    features: [
      "Real-time data updates",
      "Interactive visualizations",
      "Multiple chart types",
      "Custom filtering options",
      "Responsive layout"
    ],
    specifications: {
      "Framework": "React 18+",
      "Charts Library": "D3.js v7",
      "State Management": "Redux Toolkit",
      "UI Components": "Material-UI v5",
      "Build Tool": "Vite",
      "Browser Support": "Modern browsers",
      "Responsive": "Mobile-first design",
      "Theme Options": "Light/Dark modes",
      "Documentation": "Storybook + API docs"
    }
  },
  {
    id: 6,
    name: "Budget Plan Templates",
    category: "Business Planning",
    price: 150,
    image: "/images/products/business/budget-plan.webp",
    shortDescription: "Comprehensive financial planning and budgeting templates",
    description: "Professional budget planning templates in Excel and Google Sheets formats, including cash flow forecasting, expense tracking, investment planning, and financial goal setting. Suitable for personal and business use.",
    features: [
      "Cash flow forecasting",
      "Expense categorization",
      "Investment tracking",
      "Financial projections",
      "Automated calculations"
    ],
    specifications: {
      "File Formats": "Excel (.xlsx), Google Sheets",
      "Template Count": "15+ templates",
      "Excel Version": "2016 or later",
      "Formulas": "Protected, automated calculations",
      "Customization": "Fully customizable",
      "Data Import": "CSV import support",
      "Reporting": "Auto-generated reports",
      "Language": "English",
      "Updates": "Quarterly template updates"
    }
  },
  {
    id: 7,
    name: "Business Analytics Dashboard",
    category: "Business Analytics",
    price: 253,
    image: "/images/products/business/analytics-dashboard.webp",
    shortDescription: "Enterprise-grade business analytics and reporting solution",
    description: "Comprehensive business analytics dashboard featuring KPI tracking, sales analytics, customer insights, revenue forecasting, and customizable reporting tools. Built with modern BI practices and data visualization techniques.",
    features: [
      "Real-time KPI tracking",
      "Sales performance analytics",
      "Customer behavior insights",
      "Revenue forecasting",
      "Custom report builder"
    ],
    specifications: {
      "Dashboard Framework": "Power BI / Tableau",
      "Data Sources": "Multiple source integration",
      "Update Frequency": "Real-time / Scheduled",
      "Export Formats": "PDF, Excel, CSV, Image",
      "Visualization Types": "20+ chart types",
      "Custom Metrics": "Unlimited custom KPIs",
      "User Access": "Role-based access control",
      "Mobile Support": "Responsive design",
      "Integration": "API available"
    }
  },
  {
    id: 8,
    name: "Business Articles of Incorporation templates",
    category: "Legal Documents",
    price: 201,
    image: "/images/products/legal/incorporation.webp",
    shortDescription: "Professional incorporation document templates for all states",
    description: "State-specific articles of incorporation templates prepared by legal professionals. Includes all necessary forms, bylaws, operating agreements, and compliance documents for corporation and LLC formation.",
    features: [
      "State-specific templates",
      "Legal compliance checked",
      "Filing instructions",
      "Amendment procedures",
      "Corporate bylaws"
    ],
    specifications: {
      "Document Types": "LLC, C-Corp, S-Corp, Non-profit",
      "State Coverage": "All 50 US states",
      "Format": "Word, PDF (fillable)",
      "Legal Review": "Attorney reviewed",
      "Updates": "Annual legal updates",
      "Compliance": "State-specific requirements",
      "Support": "Legal guidance included",
      "Customization": "Easy form filling",
      "Additional Forms": "EIN application included"
    }
  },
  {
    id: 9,
    name: "Business Client Onboarding Templates",
    category: "Business Operations",
    price: 145,
    image: "/images/products/business/onboarding.webp",
    shortDescription: "Complete client onboarding system and documentation",
    description: "Professional client onboarding toolkit including workflow templates, questionnaires, welcome packets, service agreements, and automated onboarding processes. Designed for agencies, consultants, and service providers.",
    features: [
      "Onboarding workflows",
      "Client questionnaires",
      "Welcome packet templates",
      "Process automation",
      "Progress tracking"
    ],
    specifications: {
      "Templates Included": "25+ documents",
      "Workflow Steps": "Customizable stages",
      "Format": "Word, PDF, Digital forms",
      "Automation": "Email sequences included",
      "CRM Integration": "Major CRM compatible",
      "Industry": "Service-based businesses",
      "Customization": "White-label ready",
      "GDPR Compliant": "Yes",
      "Language": "Multi-language support"
    }
  },
  {
    id: 10,
    name: "Business Model Templates",
    category: "Business Planning",
    price: 196,
    image: "/images/products/business/business-model.webp",
    shortDescription: "Strategic business model planning and analysis templates",
    description: "Comprehensive business model development toolkit featuring canvas templates, value proposition design, market analysis frameworks, revenue model planning, and strategic implementation guides.",
    features: [
      "Business model canvas",
      "Value proposition tools",
      "Market analysis templates",
      "Revenue modeling",
      "Strategy frameworks"
    ],
    specifications: {
      "Template Types": "10+ strategic frameworks",
      "Format": "PowerPoint, PDF, Miro",
      "Use Cases": "Startups, Enterprise",
      "Methodology": "Lean Canvas, BMC",
      "Examples": "20+ case studies",
      "Workshop Material": "Facilitator guides",
      "Tools": "Financial modeling sheets",
      "Updates": "Quarterly",
      "Support": "Strategy consulting"
    }
  },
  {
    id: 11,
    name: "Business Plan Templates",
    category: "Business Planning",
    price: 222,
    image: "/images/products/business/business-plan.webp",
    shortDescription: "Professional business plan templates and guides",
    description: "Comprehensive business plan templates with examples and guides",
    features: [
      "Multiple formats",
      "Financial projections",
      "Market analysis",
      "Executive summaries",
      "Sample content"
    ],
    specifications: {
      "Template Formats": "Word, PDF, PowerPoint",
      "Plan Types": "Standard, Lean, Pitch Deck",
      "Financial Models": "5-year projections",
      "Industry Examples": "25+ sample plans",
      "Research Tools": "Market analysis templates",
      "Compliance": "SBA guidelines compliant",
      "Customization": "Fully editable",
      "Support": "Expert review available",
      "Updates": "Quarterly"
    }
  },
  {
    id: 12,
    name: "Business Strategy Handbooks",
    category: "Business Strategy",
    price: 278,
    image: "/images/products/business/strategy-handbook.webp",
    shortDescription: "Comprehensive business strategy guides and handbooks",
    description: "In-depth handbooks covering various aspects of business strategy",
    features: [
      "Strategy frameworks",
      "Case studies",
      "Implementation guides",
      "Best practices",
      "Tools and templates"
    ],
    specifications: {
      "Content Length": "500+ pages",
      "Topics Covered": "15+ strategy areas",
      "Case Studies": "50+ real examples",
      "Frameworks": "30+ strategy tools",
      "Format": "PDF, eBook, Print-ready",
      "Academic Level": "MBA-standard content",
      "Resources": "Templates & worksheets",
      "Updates": "Annual editions",
      "Access": "Digital + Print options"
    }
  },
  {
    id: 13,
    name: "Company Deck Templates",
    category: "Business Presentations",
    price: 191,
    image: "/images/products/business/company-deck.webp",
    shortDescription: "Professional company presentation deck templates",
    description: "Modern presentation templates for company pitches and presentations",
    features: [
      "Multiple designs",
      "Easy customization",
      "Professional layouts",
      "Animation options",
      "Sample content"
    ],
    specifications: {
      "Slide Count": "100+ unique slides",
      "Format": "PowerPoint, Keynote, Google Slides",
      "Resolution": "4K, 16:9 and 4:3",
      "Elements": "1000+ vector icons",
      "Animations": "Custom transitions",
      "Color Schemes": "10+ themes",
      "Image Placeholders": "Smart objects",
      "Charts": "Editable infographics",
      "Compatibility": "Office 2016+"
    }
  },
  {
    id: 14,
    name: "Company Profile Templates",
    category: "Business Documents",
    price: 140,
    image: "/images/products/business/company-profile.webp",
    shortDescription: "Professional company profile templates and designs",
    description: "Modern templates for creating impressive company profiles",
    features: [
      "Multiple formats",
      "Professional design",
      "Easy customization",
      "Sample content",
      "Best practices"
    ],
    specifications: {
      "Template Variations": "15+ designs",
      "Format": "InDesign, Word, PDF",
      "Page Count": "20+ pages per template",
      "Sections": "Complete company sections",
      "Images": "Stock photos included",
      "Print Ready": "300 DPI, CMYK",
      "Size Options": "A4 and US Letter",
      "Elements": "Vector graphics included",
      "Customization": "Brand guidelines ready"
    }
  },
  {
    id: 15,
    name: "Contracts & Agreements Templates",
    category: "Legal Documents",
    price: 273,
    image: "/images/products/legal/contracts.webp",
    shortDescription: "Professional legal contract and agreement templates",
    description: "Comprehensive collection of legal contract templates",
    features: [
      "Multiple contract types",
      "Legal compliance",
      "Customizable terms",
      "Usage guidelines",
      "Sample clauses"
    ],
    specifications: {
      "Document Types": "Service, Employment, Partnership, Sales",
      "Format": "Word, PDF (fillable)",
      "Legal Review": "Attorney reviewed",
      "Customization": "Fully editable templates",
      "Compliance": "State-specific requirements",
      "Support": "Legal guidance included",
      "Updates": "Annual legal updates",
      "Language": "English",
      "Additional Forms": "Amendment templates included"
    }
  },
  {
    id: 16,
    name: "cyber-security-books",
    category: "Cybersecurity Training",
    price: 350,
    image: "/images/products/security/cyber-books.webp",
    shortDescription: "Comprehensive collection of cybersecurity books and guides",
    description: "In-depth cybersecurity books covering various security topics",
    features: [
      "Multiple topics",
      "Practical examples",
      "Best practices",
      "Regular updates",
      "Support included"
    ],
    specifications: {
      "Book Count": "25+ comprehensive guides",
      "Format": "PDF, EPUB, MOBI",
      "Topics Covered": "Network Security, Ethical Hacking, Forensics",
      "Difficulty Level": "Beginner to Advanced",
      "Pages": "5000+ total pages",
      "Updates": "Quarterly content updates",
      "Support": "Email support included",
      "Access Period": "Lifetime",
      "Certification": "Study guides for major certs"
    }
  },
  {
    id: 17,
    name: "Hacker's Library Bundle",
    category: "Cybersecurity Training",
    price: 186,
    image: "/images/products/security/windows-exploits.webp",
    shortDescription: "Complete cybersecurity Beginner to Advanced Resource Bundle",
    description: "Unlock your cybersecurity potential with the Hacker's Library Bundle – a powerful, all-in-one resource pack crafted for just ₹49 to take you from beginner to advanced in the ethical hacking world. Whether you're just starting out or prepping for top certifications like CEH, OSCP, or Security+, this 100+ hour bundle offers everything you need: hands-on labs, exploit demos for Windows and Linux, cheat sheets, mind maps, and real-world tools like Kali Linux, Metasploit, and Burp Suite. Packed with resume templates, video tutorials, and practical coding in Python, Bash, and more, it's your ultimate weapon to learn, practice, and stand out in the cybersecurity space.",
    features: [
      "Beginner friendly",
      "Resume Templates",
      "Windows Exploits",
      "Linux Exploits",
      "Video tutorials",
      "Practice exercises",
      "Hands-on labs",
      "Certification prep"
    ],
    specifications: {
      "Content Level": "Beginner to Advanced",
      "Total Hours": "100+ hours of content",
      "Tools Covered": "Kali Linux, Metasploit, Wireshark, Burp Suite",
      "Programming": "Python, Bash , Javascript , C++ , Ino",
      "Certifications": "CEH, ejpt , OSCP , NDE , DFE , EHE Security+ prep materials",
      "Resources": "Cheat sheets, Mind maps, Tools",
      "Compatibility": "Windows, Linux, macOS",
      "Prerequisites": "Basic IT knowledge"
    }
  },
  {
    id: 18,
    name: "Cybersecurity Shortlisted Resumes",
    category: "Career Resources",
    price: 119,
    image: "/images/products/career/cyber-resume.webp",
    shortDescription: "Professional resume templates for cybersecurity professionals",
    description: "ATS-friendly resume templates for cybersecurity roles",
    features: [
      "ATS optimized",
      "Multiple formats",
      "Sample content",
      "Customizable",
      "Best practices"
    ],
    specifications: {
      "Template Count": "15+ professional designs",
      "Format": "Word, PDF, LaTeX",
      "ATS Compatibility": "100% ATS-friendly",
      "Industry Focus": "Cybersecurity roles",
      "Customization": "Fully editable",
      "Sample Content": "Real examples included",
      "File Size": "Optimized for upload",
      "Updates": "Quarterly template updates",
      "Support": "Resume review included"
    }
  },
  {
    id: 19,
    name: "cybersecurity-free-tutorials",
    category: "Cybersecurity Training",
    price: 268,
    image: "/images/products/security/tutorials.webp",
    shortDescription: "Collection of cybersecurity tutorials and guides",
    description: "Comprehensive tutorials covering various cybersecurity topics",
    features: [
      "Multiple topics",
      "Practical examples",
      "Video content",
      "Regular updates",
      "Support included"
    ],
    specifications: {
      "Tutorial Count": "50+ comprehensive tutorials",
      "Format": "Video, PDF, Interactive labs",
      "Topics Covered": "Penetration Testing, Forensics, Network Security",
      "Difficulty Level": "Beginner to Intermediate",
      "Duration": "100+ hours of content",
      "Updates": "Monthly new tutorials",
      "Support": "Community forum access",
      "Access Period": "Lifetime",
      "Certification": "Completion certificates"
    }
  },
  {
    id: 20,
    name: "Datasets",
    category: "Data Science",
    price: 304,
    image: "/images/products/data/datasets.webp",
    shortDescription: "Curated datasets for data science projects and analysis",
    description: "Collection of cleaned and prepared datasets for various applications",
    features: [
      "Multiple formats",
      "Clean data",
      "Documentation",
      "Regular updates",
      "Usage guidelines"
    ],
    specifications: {
      "Dataset Count": "100+ curated datasets",
      "Format": "CSV, JSON, SQL, Parquet",
      "Data Size": "10GB+ total data",
      "Categories": "Business, Finance, Healthcare, Social",
      "Quality": "Pre-cleaned and validated",
      "Documentation": "Complete metadata included",
      "Updates": "Monthly new datasets",
      "Support": "Data analysis guidance",
      "License": "Commercial use allowed"
    }
  },
  {
    id: 21,
    name: "DevOps Autoimation Scripts",
    category: "DevOps Tools",
    price: 309,
    image: "/images/products/devops/automation.webp",
    shortDescription: "Collection of automation scripts for DevOps processes",
    description: "Comprehensive set of scripts for DevOps automation",
    features: [
      "Multiple platforms",
      "CI/CD scripts",
      "Infrastructure as code",
      "Documentation",
      "Best practices"
    ],
    specifications: {
      "Script Count": "200+ automation scripts",
      "Languages": "Bash, Python, PowerShell, YAML",
      "Platforms": "AWS, Azure, GCP, Docker, Kubernetes",
      "CI/CD Tools": "Jenkins, GitLab CI, GitHub Actions",
      "Documentation": "Complete setup guides",
      "Updates": "Monthly script updates",
      "Support": "DevOps consultation included",
      "Compatibility": "Cross-platform support",
      "Testing": "All scripts tested and verified"
    }
  },
  {
    id: 22,
    name: "Employee Handbook",
    category: "HR Documents",
    price: 181,
    image: "/images/products/hr/employee-handbook.webp",
    shortDescription: "Professional employee handbook template and guidelines",
    description: "Comprehensive template for creating company employee handbooks",
    features: [
      "Customizable content",
      "Policy templates",
      "Best practices",
      "Legal compliance",
      "Sample content"
    ],
    specifications: {
      "Template Sections": "25+ policy sections",
      "Format": "Word, PDF, Google Docs",
      "Legal Compliance": "Federal and state guidelines",
      "Customization": "Fully editable templates",
      "Industry Focus": "All business types",
      "Updates": "Annual legal updates",
      "Support": "HR consultation included",
      "Language": "English",
      "Additional Forms": "Policy acknowledgment forms"
    }
  },
  {
    id: 23,
    name: "Employment Agreement Templates",
    category: "Legal Documents",
    price: 263,
    image: "/images/products/legal/employment-agreement.webp",
    shortDescription: "Professional employment agreement templates",
    description: "Legal templates for various types of employment agreements",
    features: [
      "Multiple formats",
      "Legal compliance",
      "Customizable terms",
      "Sample clauses",
      "Usage guidelines"
    ],
    specifications: {
      "Agreement Types": "Full-time, Part-time, Contract, Executive",
      "Format": "Word, PDF (fillable)",
      "Legal Review": "Attorney reviewed",
      "State Coverage": "All 50 US states",
      "Customization": "Fully editable terms",
      "Compliance": "Federal and state labor laws",
      "Support": "Legal guidance included",
      "Updates": "Annual legal updates",
      "Additional Forms": "Amendment and termination forms"
    }
  },
  {
    id: 24,
    name: "ESP8266 Scripts and Exploits",
    category: "IoT Security",
    price: 248,
    image: "/images/products/security/esp8266.webp",
    shortDescription: "Collection of scripts and tools for ESP8266 development",
    description: "Comprehensive set of scripts and exploits for ESP8266",
    features: [
      "Multiple scripts",
      "Documentation",
      "Example projects",
      "Regular updates",
      "Support included"
    ],
    specifications: {
      "Script Count": "50+ ESP8266 scripts",
      "Languages": "C++, Arduino, Python",
      "Applications": "WiFi, Security, Automation",
      "Documentation": "Complete setup guides",
      "Hardware": "ESP8266 compatible",
      "Updates": "Monthly script updates",
      "Support": "Technical support included",
      "Examples": "Real-world projects",
      "Compatibility": "Arduino IDE, PlatformIO"
    }
  },
  {
    id: 25,
    name: "Expense Report Templates",
    category: "Financial Management",
    price: 114,
    image: "/images/products/finance/expense-report.webp",
    shortDescription: "Professional expense report templates and tracking tools",
    description: "Complete set of templates for expense reporting and tracking",
    features: [
      "Multiple formats",
      "Automated calculations",
      "Customizable",
      "Export options",
      "Sample reports"
    ],
    specifications: {
      "Template Count": "20+ expense report formats",
      "Format": "Excel, Google Sheets, PDF",
      "Automation": "Auto-calculations and formulas",
      "Categories": "Business, Personal, Travel",
      "Export Options": "PDF, Excel, CSV",
      "Customization": "Fully editable templates",
      "Updates": "Quarterly template updates",
      "Support": "Financial guidance included",
      "Compliance": "Tax-compliant formats"
    }
  },
  {
    id: 26,
    name: "Independent Contractor Agreement Templates",
    category: "Legal Documents",
    price: 176,
    image: "/images/products/legal/contractor-agreement.webp",
    shortDescription: "Professional contractor agreement templates",
    description: "Legal templates for independent contractor agreements",
    features: [
      "Legal compliance",
      "Customizable terms",
      "Multiple formats",
      "Sample clauses",
      "Usage guidelines"
    ],
    specifications: {
      "Agreement Types": "Service, Consulting, Freelance, Project-based",
      "Format": "Word, PDF (fillable)",
      "Legal Review": "Attorney reviewed",
      "State Coverage": "All 50 US states",
      "Customization": "Fully editable terms",
      "Compliance": "Federal contractor laws",
      "Support": "Legal guidance included",
      "Updates": "Annual legal updates",
      "Additional Forms": "Amendment and termination forms"
    }
  },
  {
    id: 27,
    name: "Investment Proposal Templates",
    category: "Financial Management",
    price: 242,
    image: "/images/products/finance/investment-proposal.webp",
    shortDescription: "Professional investment proposal templates and guides",
    description: "Complete templates for creating investment proposals",
    features: [
      "Multiple formats",
      "Financial models",
      "Customizable",
      "Sample content",
      "Best practices"
    ],
    specifications: {
      "Template Count": "15+ proposal formats",
      "Format": "PowerPoint, Word, PDF",
      "Financial Models": "ROI, NPV, IRR calculations",
      "Industries": "Tech, Real Estate, Manufacturing",
      "Customization": "Fully editable templates",
      "Updates": "Quarterly template updates",
      "Support": "Financial consultation included",
      "Examples": "Real proposal samples",
      "Compliance": "SEC guidelines compliant"
    }
  },
  {
    id: 28,
    name: "Linux-Tools",
    category: "System Administration",
    price: 299,
    image: "/images/products/system/linux-tools.webp",
    shortDescription: "Comprehensive collection of Linux tools and utilities",
    description: "Collection of essential Linux tools for system administration",
    features: [
      "Multiple tools",
      "Documentation",
      "Regular updates",
      "Support included",
      "Usage guides"
    ],
    specifications: {
      "Tool Count": "100+ Linux utilities",
      "Categories": "System, Network, Security, Monitoring",
      "Distributions": "Ubuntu, CentOS, RHEL, Debian",
      "Documentation": "Complete setup guides",
      "Updates": "Monthly tool updates",
      "Support": "Technical support included",
      "Compatibility": "Linux kernel 4.0+",
      "Installation": "Package managers included",
      "Testing": "All tools tested and verified"
    }
  },
  {
    id: 29,
    name: "Marketing Plan Templates",
    category: "Marketing Strategy",
    price: 217,
    image: "/images/products/marketing/marketing-plan.webp",
    shortDescription: "Professional marketing plan templates and guides",
    description: "Complete templates for creating marketing strategies and plans",
    features: [
      "Multiple formats",
      "Strategy frameworks",
      "Campaign planning",
      "Sample content",
      "Best practices"
    ],
    specifications: {
      "Template Count": "20+ marketing plan formats",
      "Format": "PowerPoint, Word, PDF",
      "Industries": "B2B, B2C, SaaS, E-commerce",
      "Frameworks": "SWOT, 4Ps, Customer Journey",
      "Customization": "Fully editable templates",
      "Updates": "Quarterly template updates",
      "Support": "Marketing consultation included",
      "Examples": "Real marketing plan samples",
      "Tools": "Budget calculators included"
    }
  },
  {
    id: 30,
    name: "Non-Disclosure Agreement Templates",
    category: "Legal Documents",
    price: 135,
    image: "/images/products/legal/nda.webp",
    shortDescription: "Professional NDA templates for various purposes",
    description: "Legal templates for non-disclosure agreements",
    features: [
      "Multiple versions",
      "Legal compliance",
      "Customizable terms",
      "Sample clauses",
      "Usage guidelines"
    ],
    specifications: {
      "NDA Types": "Mutual, Unilateral, Employee, Vendor",
      "Format": "Word, PDF (fillable)",
      "Legal Review": "Attorney reviewed",
      "State Coverage": "All 50 US states",
      "Customization": "Fully editable terms",
      "Compliance": "Federal and state laws",
      "Support": "Legal guidance included",
      "Updates": "Annual legal updates",
      "Additional Forms": "Amendment and termination forms"
    }
  },
  {
    id: 31,
    name: "Offer Letter Templates",
    category: "HR Documents",
    price: 171,
    image: "/images/products/hr/offer-letter.webp",
    shortDescription: "Professional offer letter templates for hiring",
    description: "Complete set of templates for job offer letters",
    features: [
      "Multiple formats",
      "Customizable terms",
      "Legal compliance",
      "Sample content",
      "Best practices"
    ],
    specifications: {
      "Template Count": "15+ offer letter formats",
      "Format": "Word, PDF, Google Docs",
      "Positions": "Entry, Mid, Senior, Executive",
      "Industries": "All business sectors",
      "Customization": "Fully editable templates",
      "Legal Compliance": "Federal and state labor laws",
      "Updates": "Annual legal updates",
      "Support": "HR consultation included",
      "Additional Forms": "Acceptance and rejection forms"
    }
  },
  {
    id: 32,
    name: "OSCP Study Material",
    category: "Cybersecurity Certification",
    price: 345,
    image: "/images/products/security/oscp.webp",
    shortDescription: "Comprehensive study material for OSCP certification",
    description: "Complete study guide and practice material for OSCP exam",
    features: [
      "Exam preparation",
      "Practice labs",
      "Study guides",
      "Sample exercises",
      "Regular updates"
    ],
    specifications: {
      "Study Material": "Complete OSCP curriculum",
      "Format": "PDF, Video, Interactive labs",
      "Lab Environment": "Virtual machines included",
      "Practice Tests": "50+ practice exercises",
      "Difficulty Level": "Advanced",
      "Updates": "Quarterly content updates",
      "Support": "24/7 instructor support",
      "Access Period": "Lifetime",
      "Certification": "OSCP exam preparation"
    }
  },
  {
    id: 33,
    name: "Presentation templates",
    category: "Business Presentations",
    price: 166,
    image: "/images/products/business/presentation.webp",
    shortDescription: "Professional presentation templates for various purposes",
    description: "Modern presentation templates for business and education",
    features: [
      "Multiple designs",
      "Animation options",
      "Easy customization",
      "Sample content",
      "Best practices"
    ],
    specifications: {
      "Template Count": "50+ presentation designs",
      "Format": "PowerPoint, Keynote, Google Slides",
      "Resolution": "4K, 16:9 and 4:3",
      "Elements": "500+ vector icons",
      "Animations": "Custom transitions",
      "Color Schemes": "15+ professional themes",
      "Image Placeholders": "Smart objects",
      "Charts": "Editable infographics",
      "Compatibility": "Office 2016+"
    }
  },
  {
    id: 34,
    name: "Printable Study Planners",
    category: "Educational Resources",
    price: 104,
    image: "/images/products/education/study-planner.webp",
    shortDescription: "Printable study planners and organizers",
    description: "Collection of printable planners for effective studying",
    features: [
      "Multiple formats",
      "Customizable",
      "Print-ready",
      "Digital versions",
      "Usage guides"
    ],
    specifications: {
      "Planner Count": "25+ study planner designs",
      "Format": "PDF, Word, Google Docs",
      "Page Sizes": "A4, Letter, A5",
      "Types": "Daily, Weekly, Monthly, Semester",
      "Customization": "Fully editable templates",
      "Print Quality": "300 DPI, Print-ready",
      "Updates": "Quarterly template updates",
      "Support": "Study guidance included",
      "Digital Access": "Mobile-friendly versions"
    }
  },
  {
    id: 35,
    name: "Privacy Policy Templates",
    category: "Legal Documents",
    price: 130,
    image: "/images/products/legal/privacy-policy.webp",
    shortDescription: "Professional privacy policy templates",
    description: "Legal templates for website and app privacy policies",
    features: [
      "GDPR compliant",
      "Customizable",
      "Multiple versions",
      "Usage guidelines",
      "Regular updates"
    ],
    specifications: {
      "Policy Types": "Website, App, E-commerce, SaaS",
      "Format": "Word, PDF, HTML",
      "Legal Compliance": "GDPR, CCPA, COPPA",
      "Customization": "Fully editable templates",
      "Updates": "Annual legal updates",
      "Support": "Legal guidance included",
      "Language": "English",
      "Additional Forms": "Cookie policy templates",
      "Coverage": "International compliance"
    }
  },
  {
    id: 36,
    name: "Python API Testing Tools",
    category: "Python Development",
    price: 258,
    image: "/images/products/python/api-testing.webp",
    shortDescription: "Collection of Python tools for API testing",
    description: "Comprehensive set of tools for testing APIs with Python",
    features: [
      "API testing tools",
      "Documentation",
      "Example tests",
      "Best practices",
      "Support included"
    ],
    specifications: {
      "Tool Count": "30+ API testing tools",
      "Frameworks": "pytest, requests, unittest",
      "API Types": "REST, GraphQL, SOAP",
      "Documentation": "Complete setup guides",
      "Examples": "Real API test cases",
      "Updates": "Monthly tool updates",
      "Support": "Technical support included",
      "Compatibility": "Python 3.7+",
      "Testing": "All tools tested and verified"
    }
  },
  {
    id: 37,
    name: "Python Resume Parser Tool",
    category: "Python Development",
    price: 212,
    image: "/images/products/python/resume-parser.webp",
    shortDescription: "Python tool for parsing and analyzing resumes",
    description: "Advanced resume parsing tool built with Python",
    features: [
      "Resume parsing",
      "Data extraction",
      "Format support",
      "Customizable",
      "Documentation"
    ],
    specifications: {
      "Supported Formats": "PDF, Word, TXT, HTML",
      "Python Version": "Python 3.8+",
      "Libraries": "PyPDF2, python-docx, NLTK",
      "Extraction Fields": "Name, Contact, Skills, Experience",
      "Documentation": "Complete setup guides",
      "Updates": "Monthly tool updates",
      "Support": "Technical support included",
      "Compatibility": "Cross-platform",
      "Testing": "All formats tested and verified"
    }
  },
  {
    id: 38,
    name: "Python-for-Security-and-Networking",
    category: "Network Security",
    price: 319,
    image: "/images/products/security/python-security.webp",
    shortDescription: "Python tools for security and networking",
    description: "Collection of Python tools for security testing and networking",
    features: [
      "Security tools",
      "Network testing",
      "Documentation",
      "Regular updates",
      "Support included"
    ],
    specifications: {
      "Tool Count": "40+ security tools",
      "Python Version": "Python 3.7+",
      "Categories": "Network scanning, Vulnerability assessment, Forensics",
      "Libraries": "Scapy, Requests, Cryptography",
      "Documentation": "Complete setup guides",
      "Updates": "Monthly tool updates",
      "Support": "Technical support included",
      "Compatibility": "Cross-platform",
      "Testing": "All tools tested and verified"
    }
  },
  {
    id: 39,
    name: "Royality Free Music",
    category: "Digital Media",
    price: 237,
    image: "/images/products/media/royalty-free-music.webp",
    shortDescription: "Collection of royalty-free music tracks",
    description: "High-quality royalty-free music for various purposes",
    features: [
      "Multiple genres",
      "Commercial license",
      "High quality",
      "Regular updates",
      "Usage rights"
    ],
    specifications: {
      "Track Count": "100+ music tracks",
      "Genres": "Electronic, Ambient, Corporate, Cinematic",
      "Format": "MP3, WAV, FLAC",
      "Quality": "320kbps MP3, 44.1kHz WAV",
      "License": "Commercial use allowed",
      "Duration": "30 seconds to 5 minutes",
      "Updates": "Monthly new tracks",
      "Support": "Music consultation included",
      "Usage Rights": "Unlimited commercial use"
    }
  },
  {
    id: 40,
    name: "Sales Proposal Template",
    category: "Business Documents",
    price: 160,
    image: "/images/products/business/sales-proposal.webp",
    shortDescription: "Professional sales proposal templates",
    description: "Complete templates for creating sales proposals",
    features: [
      "Multiple formats",
      "Customizable",
      "Sample content",
      "Best practices",
      "Usage guides"
    ],
    specifications: {
      "Template Count": "20+ proposal formats",
      "Format": "PowerPoint, Word, PDF",
      "Industries": "B2B, B2C, SaaS, Consulting",
      "Customization": "Fully editable templates",
      "Updates": "Quarterly template updates",
      "Support": "Sales consultation included",
      "Examples": "Real proposal samples",
      "Tools": "ROI calculators included",
      "Best Practices": "Sales methodology guides"
    }
  },
  {
    id: 41,
    name: "Security Blue Team Study Material",
    category: "Cybersecurity Training",
    price: 335,
    image: "/images/products/security/blue-team.webp",
    shortDescription: "Study material for Security Blue Team certification",
    description: "Comprehensive study material for blue team security",
    features: [
      "Study guides",
      "Practice labs",
      "Case studies",
      "Regular updates",
      "Support included"
    ],
    specifications: {
      "Study Material": "Complete Blue Team curriculum",
      "Format": "PDF, Video, Interactive labs",
      "Lab Environment": "Virtual machines included",
      "Practice Tests": "40+ practice exercises",
      "Difficulty Level": "Intermediate to Advanced",
      "Updates": "Quarterly content updates",
      "Support": "24/7 instructor support",
      "Access Period": "Lifetime",
      "Certification": "Blue Team exam preparation"
    }
  },
  {
    id: 42,
    name: "SEO Audit Checklist Templates",
    category: "Digital Marketing",
    price: 155,
    image: "/images/products/marketing/seo-audit.webp",
    shortDescription: "Professional SEO audit checklist templates",
    description: "Complete templates for conducting SEO audits",
    features: [
      "Comprehensive checks",
      "Customizable",
      "Best practices",
      "Regular updates",
      "Usage guides"
    ],
    specifications: {
      "Checklist Count": "15+ audit templates",
      "Format": "Excel, PDF, Google Sheets",
      "Audit Types": "Technical, Content, Local, E-commerce",
      "Customization": "Fully editable templates",
      "Updates": "Quarterly template updates",
      "Support": "SEO consultation included",
      "Tools": "Automated checklists",
      "Best Practices": "Industry standards included",
      "Reporting": "Professional report templates"
    }
  },
  {
    id: 43,
    name: "Social Media Strategy Documents",
    category: "Digital Marketing",
    price: 207,
    image: "/images/products/marketing/social-media.webp",
    shortDescription: "Professional social media strategy templates",
    description: "Complete templates for social media marketing strategy",
    features: [
      "Strategy frameworks",
      "Content calendars",
      "Analytics tracking",
      "Best practices",
      "Sample content"
    ],
    specifications: {
      "Template Count": "25+ strategy templates",
      "Format": "PowerPoint, Word, Excel",
      "Platforms": "Facebook, Instagram, Twitter, LinkedIn",
      "Customization": "Fully editable templates",
      "Updates": "Quarterly template updates",
      "Support": "Social media consultation included",
      "Tools": "Content calendar templates",
      "Analytics": "Performance tracking sheets",
      "Best Practices": "Industry guidelines included"
    }
  },
  {
    id: 44,
    name: "Software resumes Templates",
    category: "Career Resources",
    price: 109,
    image: "/images/products/career/software-resume.webp",
    shortDescription: "Professional resume templates for software developers",
    description: "ATS-friendly resume templates for software professionals",
    features: [
      "ATS optimized",
      "Multiple formats",
      "Sample content",
      "Customizable",
      "Best practices"
    ],
    specifications: {
      "Template Count": "20+ professional designs",
      "Format": "Word, PDF, LaTeX",
      "ATS Compatibility": "100% ATS-friendly",
      "Industry Focus": "Software development roles",
      "Customization": "Fully editable",
      "Sample Content": "Real examples included",
      "File Size": "Optimized for upload",
      "Updates": "Quarterly template updates",
      "Support": "Resume review included"
    }
  },
  {
    id: 45,
    name: "Steganography",
    category: "Cybersecurity Tools",
    price: 294,
    image: "/images/products/security/steganography.webp",
    shortDescription: "Collection of steganography tools and utilities",
    description: "Complete set of tools for steganography applications",
    features: [
      "Multiple tools",
      "Documentation",
      "Example projects",
      "Regular updates",
      "Support included"
    ],
    specifications: {
      "Tool Count": "15+ steganography tools",
      "Languages": "Python, C++, Java",
      "File Types": "Image, Audio, Video, Text",
      "Documentation": "Complete setup guides",
      "Examples": "Real-world projects",
      "Updates": "Monthly tool updates",
      "Support": "Technical support included",
      "Compatibility": "Cross-platform",
      "Testing": "All tools tested and verified"
    }
  },
  {
    id: 46,
    name: "Terms & Conditions Templates",
    category: "Legal Documents",
    price: 125,
    image: "/images/products/legal/terms-conditions.webp",
    shortDescription: "Professional terms and conditions templates",
    description: "Legal templates for website and app terms of service",
    features: [
      "Legal compliance",
      "Customizable",
      "Multiple versions",
      "Usage guidelines",
      "Regular updates"
    ],
    specifications: {
      "Template Types": "Website, App, E-commerce, SaaS",
      "Format": "Word, PDF, HTML",
      "Legal Compliance": "Federal and state laws",
      "Customization": "Fully editable templates",
      "Updates": "Annual legal updates",
      "Support": "Legal guidance included",
      "Language": "English",
      "Additional Forms": "User agreement templates",
      "Coverage": "International compliance"
    }
  },
  {
    id: 47,
    name: "Website Elements",
    category: "Web Development",
    price: 232,
    image: "/images/products/web/elements.webp",
    shortDescription: "Collection of modern website UI elements",
    description: "Complete pack of website elements and components",
    features: [
      "Multiple elements",
      "Modern design",
      "Customizable",
      "Documentation",
      "Support included"
    ],
    specifications: {
      "Element Count": "200+ UI components",
      "Frameworks": "HTML, CSS, JavaScript, React",
      "Categories": "Buttons, Forms, Navigation, Cards",
      "Documentation": "Complete setup guides",
      "Customization": "Fully customizable",
      "Updates": "Monthly new elements",
      "Support": "Technical support included",
      "Compatibility": "Modern browsers",
      "Testing": "All elements tested and verified"
    }
  },
  {
    id: 48,
    name: "Website Templates",
    category: "Web Development",
    price: 289,
    image: "/images/products/web/templates.webp",
    shortDescription: "Professional website templates for various purposes",
    description: "Modern website templates for different industries",
    features: [
      "Multiple designs",
      "Responsive",
      "Customizable",
      "Documentation",
      "Support included"
    ],
    specifications: {
      "Template Count": "50+ website designs",
      "Frameworks": "HTML, CSS, JavaScript, Bootstrap",
      "Industries": "Business, Portfolio, E-commerce, Blog",
      "Responsive": "Mobile-first design",
      "Customization": "Fully editable",
      "Updates": "Monthly new templates",
      "Support": "Technical support included",
      "Compatibility": "Modern browsers",
      "Testing": "All templates tested and verified"
    }
  },
  {
    id: 49,
    name: "Windows Hacking Tools",
    category: "Cybersecurity Tools",
    price: 314,
    image: "/images/products/security/windows-hacking.webp",
    shortDescription: "Collection of Windows hacking and security tools",
    description: "Comprehensive set of tools for Windows security testing",
    features: [
      "Multiple tools",
      "Documentation",
      "Regular updates",
      "Support included",
      "Usage guides"
    ],
    specifications: {
      "Tool Count": "60+ Windows security tools",
      "Languages": "C++, C#, PowerShell, Python",
      "Categories": "Exploitation, Privilege escalation, Persistence",
      "Documentation": "Complete setup guides",
      "Updates": "Monthly tool updates",
      "Support": "Technical support included",
      "Compatibility": "Windows 7/8/10/11",
      "Testing": "All tools tested and verified",
      "Legal": "Educational use only"
    }
  },
  {
    id: 50,
    name: "Windows exploits",
    category: "Cybersecurity Tools",
    price: 330,
    image: "/images/products/security/zero-to-mastery.webp",
    shortDescription: "Collection of Windows security exploits and tools",
    description: "Comprehensive collection of Windows security testing tools",
    features: [
      "Multiple exploits",
      "Documentation",
      "Regular updates",
      "Support included",
      "Usage guides"
    ],
    specifications: {
      "Exploit Count": "80+ Windows exploits",
      "Languages": "C++, Assembly, Python",
      "Categories": "Buffer overflow, ROP, Kernel exploits",
      "Documentation": "Complete setup guides",
      "Updates": "Monthly exploit updates",
      "Support": "Technical support included",
      "Compatibility": "Windows 7/8/10/11",
      "Testing": "All exploits tested and verified",
      "Legal": "Educational use only"
    }
  }
];

const getProductImageFolder = (productName) => encodeURIComponent(productName);

const getProductGallery = (productName) => {
  const folder = getProductImageFolder(productName);
  const imageFolders = ['main-photo', 'supporting-image-1', 'supporting-image-2', 'supporting-image-3', 'supporting-image-4', 'supporting-image-5'];

  return imageFolders.map(imageFolder => (
    productImageMap[productName]?.[imageFolder]?.[0]
      || `/images/products/${folder}/${imageFolder}/image.webp`
  ));
};

export const products = productData.map(product => ({
  ...product,
  image: getProductGallery(product.name)[0],
  gallery: getProductGallery(product.name)
}));

export const getProductById = (id) => {
  return products.find(product => product.id === parseInt(id));
}; 